import firebase from "firebase";
import moment from "moment";
import Countdown from "@/components/Countdown/Countdown.vue";

//vuex action
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {
    Countdown: Countdown
  },
  computed: {
    ...mapGetters(["getZipCode", "getMealRequests", "hasApplied"]),
    zipCode() {
      return this.getZipCode;
    },
    mealRequests() {
      return this.getMealRequests;
    },
    stillTime() {
      return moment().hour() < 10;
    },
    duration() {
      if (this.stillTime) {
        const now = moment();
        const then = moment();
        then.hours(10);
        then.minutes(0);
        then.seconds(0);
        return then.unix() - now.unix();
      } else {
        return 0;
      }
    }
  },
  created() {
    if (this.stillTime) {
      // has applied ?
      this.getDashboardData();
    }
  },
  methods: {
    ...mapActions([
      "dispatchLogout",
      "getDashboardData",
      "dispatchRequestMeal"
    ]),
    requestMeal() {
      this.dispatchRequestMeal();
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.dispatchLogout();
          window.location.href = "/";
        });
    }
  }
};
